import {r as a} from '@theme/theme-sections';
import {F as u} from '@theme/flickity';
import {S as m} from '@theme/slider-progress-indicator';
import {s as p} from '@theme/section-slider-lifecycle';
import '@theme/_commonjsHelpers';
const d = 'complete-the-look';
var l, c, h;
const g =
    ((h = (c = (l = window.Shopify) == null ? void 0 : l.theme) == null ? void 0 : c.sections) == null
      ? void 0
      : h.registered) || {},
  S = typeof g[d] > 'u',
  s = {
    grid: '.complete-the-look__grid',
    products: '[data-products]',
    productItem: '.complete-the-look__product-list-item',
    progressBar: '[data-slider-progress-bar]',
  };
S &&
  a(d, {
    ...p,
    onLoad() {
      this.teardown(),
        (this.sectionActive = !0),
        (this.slider = null),
        (this.elements = {
          section: this.container.closest('.shopify-section') || this.container,
          grid: this.container.querySelector(s.grid),
          productsEl: this.container.querySelector(s.products),
          progressBar: this.container.querySelector(s.progressBar),
        }),
        this.loadComplementaryProducts();
    },
    initSlider() {
      const t = this.elements.productsEl;
      !this.isSectionActive() ||
        !t ||
        (this.destroySlider(),
        (this.slider = new u(t, {
          prevNextButtons: !0,
          pageDots: !1,
          cellAlign: 'left',
          contain: !0,
          watchCSS: !0,
          draggable: !0,
          arrowShape: 'M62.5 77.6517L34.8484 50L62.5 22.3484L65.1517 25L40.1517 50L65.1517 75L62.5 77.6517Z',
        })),
        this.elements.progressBar &&
          (this.progressIndicator = new m({element: this.elements.progressBar, slider: this.slider})),
        this.scheduleSliderResize());
    },
    loadComplementaryProducts() {
      var i;
      (i = this.requestController) == null || i.abort(),
        cancelAnimationFrame(this.initFrame),
        (this.initFrame = null),
        this.destroySlider(),
        (this.requestController = new AbortController());
      const t = this.requestController;
      fetch(this.container.dataset.url, {signal: t.signal})
        .then((e) => e.text())
        .then((e) => {
          if (!this.isSectionActive() || t !== this.requestController) return;
          const r = document.createElement('div');
          r.innerHTML = e;
          const o = r.querySelector(`[data-section-id="${this.id}"]`),
            n = o == null ? void 0 : o.querySelector(s.products);
          if (!n || !n.innerHTML.trim().length) {
            this.hideSection();
            return;
          }
          this.showSection(),
            (this.elements.productsEl.innerHTML = n.innerHTML),
            this.updateProductCountClass(),
            (this.initFrame = requestAnimationFrame(() => {
              (this.initFrame = null), this.isSectionActive() && this.initSlider();
            }));
        })
        .catch((e) => {
          e.name !== 'AbortError' &&
            (console.warn(e), this.isSectionActive() && t === this.requestController && this.hideSection());
        })
        .finally(() => {
          t === this.requestController && (this.requestController = null);
        });
    },
    updateProductCountClass() {
      var i, e;
      if (!((i = this.elements) != null && i.grid) || !((e = this.elements) != null && e.productsEl)) return;
      const t = Math.min(this.elements.productsEl.querySelectorAll(s.productItem).length, 3);
      Array.from(this.elements.grid.classList)
        .filter((r) => r.startsWith('complete-the-look__grid--'))
        .forEach((r) => this.elements.grid.classList.remove(r)),
        this.elements.grid.classList.add(`complete-the-look__grid--${t}`);
    },
  });
